export const MessageSection = ({
    message
}) => {
    return (
        <section className="px-10 py-20 flex-center w-full">
            <p className="message-section">{message}</p>
        </section>
    )
}